<template>
    <div>
        <div id="container2" style="width: 100%" />
    </div>
</template>

<script>
    import { Chart } from '@antv/g2';


    export default {
        name: "areaChart",
        data(){
            return{
               // data:
            }
        },
        props:["data"],
        watch:{
            data:function(newVal,oldVal){
                this.data = newVal;
                this.changChats(newVal)
              console.log("this.datathis.data",this.data)
            },
        },
        methods:{
            changChats(data){
                this.chart.clear(); // 清理所有
                this.chart.source(data); // 重新加载数据
                // if(data.length==1){
                //     this.chart
                //         .point()
                //         .position('label*value')
                //         .size(2)
                //         .shape('circle')
                //         .style({lineWidth:1})
                // }
                this.chart
                    .area()
                    .adjust('stack')
                    .position('year*value')
                    .color('country');
                this.chart
                    .line()
                    .adjust('stack')
                    .position('year*value')
                    .color('country');
                // this.chart.area().position('year*value') ;
                // this.chart.line().position('year*value') ;
                this.chart.render();
            },
            newCharts(){
                this.chart = new Chart({
                    container: 'container2',
                    autoFit: true,
                    height: 500,
                });

                this.chart.data(this.data);
                // this.chart.scale({
                //     value: {
                //         min: 0
                //     },
                //     label: {
                //         tickCount: 8,
                //         // base: 10
                //         // range: [ 0, 1 ]
                //     }
                // });
                this.chart.scale('year', {
                    // type: 'linear',
                    // tickInterval: 50,
                });
                this.chart.scale('value', {
                    nice: true,
                });

                this.chart.tooltip({
                    showCrosshairs: true,
                    shared: true,
                });

                this.chart
                    .area()
                    .adjust('stack')
                    .position('year*value')
                    .color('country');
                this.chart
                    .line()
                    .adjust('stack')
                    .position('year*value')
                    .color('country');

                // this.chart.interaction('element-highlight');

                // this.chart.render();

            }
        },
        mounted() {
            this.newCharts()
        }
    }
</script>

<style scoped>

</style>
